type LoaderListener = (isLoading: boolean, message?: string) => void;

class LoaderUtilClass {
  private activeCount = 0;
  private message: string = "Loading...";
  private listeners = new Set<LoaderListener>();

  showLoading(message?: string): void {
    this.activeCount += 1;

    if (message) {
      this.message = message;
    }

    this.notify();
  }

  hideLoading(): void {
    if (this.activeCount > 0) {
      this.activeCount -= 1;
    }

    if (this.activeCount === 0) {
      this.message = "Loading...";
    }

    this.notify();
  }

  resetLoading(): void {
    this.activeCount = 0;
    this.message = "Loading...";
    this.notify();
  }

  isLoading(): boolean {
    return this.activeCount > 0;
  }

  getMessage(): string {
    return this.message;
  }

  subscribe(listener: LoaderListener): () => void {
    this.listeners.add(listener);

    listener(this.isLoading(), this.message);

    return () => {
      this.listeners.delete(listener);
    };
  }

  private notify(): void {
    const loading = this.isLoading();

    this.listeners.forEach(listener =>
      listener(loading, this.message)
    );
  }
}

export const LoaderUtil = new LoaderUtilClass();